import { useLazyQuery } from '@apollo/client';
import { useState } from 'react';
import moment from 'moment';
import { parseObjectArrayToIdArray } from '../../../../utils/utils';
import { SIZE_AND_WEIGHT_SEARCH_QUERY } from '../../Query/SizeAndWeightSearchQuery';

const initialState = {
  ori_ids: [],
  started_at_search_start_date: moment().local().subtract(1, 'month').startOf('day'),
  ended_at_search_end_date: moment().local().startOf('day'),
  first_name: "",
  last_name: "",
  violation_identified: null,
  court_action: null,
  dimension_violation_identified: null,
  road_type_ids: [],
  state_highway_ids: [],
  area_ids: [],
  officer_ids: [],
  primary: false,
};

const useSearch = (userId, oriId, onCompletedCallback) => {
  const [searchResults, setSearchResults] = useState(null);
  const [searchState, setSearchState] = useState(initialState);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const [searchSizeAndWeight, { loading, error }] = useLazyQuery(SIZE_AND_WEIGHT_SEARCH_QUERY, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setSearchResults(data.searchSizeAndWeights);
      !!onCompletedCallback && onCompletedCallback();
    },
  });

  const handleSearch = (state, perPage, pageNum) => {
    const pageForQuery = pageNum || page;
    const perPageForQuery = perPage || resultsPerPage;
    const formattedState = formatSearchStr({ ...state }, oriId);  
    if (perPage && perPage !== resultsPerPage) setResultsPerPage(perPage);
    if (pageNum && pageNum !== page) setPage(pageNum);
    searchSizeAndWeight({ variables: { perPage: perPageForQuery, page: pageForQuery, json: formattedState, originatorId: userId } });
  };

  const handleChange = (value, name) => {
    setSearchState(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleReset = () => {
    setSearchState(initialState);
  };



  return {
    searchResults,
    setSearchResults,
    searchState,
    resultsPerPage,
    setResultsPerPage,
    handleSearch,
    handleChange,
    handleReset,
    loading,
    error,
  };
};

const formatSearchStr = (obj, oriId) => {
  let res = { ...obj };
  res.ori_ids = [oriId]; 
  res.person_attributes = { first_name: res.first_name?.trim() || null, last_name: res.last_name?.trim() || null };
  delete res.first_name;
  delete res.last_name;
  let start = res.started_at_search_start_date.clone()
  let end = res.ended_at_search_end_date.clone()
  res.road_type_ids = parseObjectArrayToIdArray(res.road_type_ids);
  res.state_highway_ids = parseObjectArrayToIdArray(res.state_highway_ids);
  res.area_ids = parseObjectArrayToIdArray(res.area_ids);
  res.officer_ids = parseObjectArrayToIdArray(res.officer_ids);
  res.violation_identified = res.violation_identified?.value;
  res.court_action = res.court_action?.value;
  res.dimension_violation_identified = res.dimension_violation_identified?.value;
  res.started_at_search_start_date = start.utc().format("YYYY-MM-DD HH:mm:ss UTC")
  res.ended_at_search_end_date =   end.utc().format("YYYY-MM-DD HH:mm:ss UTC")
  res.primary = res.primary ? 1 : 0;
  Object.keys(res).forEach(key => {
    if (res[key] === "" || (Array.isArray(res[key]) && res[key]?.length === 0)) {
      res[key] = null;
    }
  });

  return JSON.stringify(res);
};

export default useSearch;
